var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.categories),function(c){return _c('CategoryInput',{key:c,attrs:{"category":c,"services":_vm.byCategory[c],"value":_vm.value},on:{"input":_vm.servicesChange}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }